var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParticipantsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-participant-5616911 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7024 11.8759C16.7024 14.9791 14.1866 17.4949 11.0833 17.4949C7.98002 17.4949 5.46429 14.9791 5.46429 11.8759C5.46429 8.77257 7.98002 6.25684 11.0833 6.25684C14.1866 6.25684 16.7024 8.77257 16.7024 11.8759ZM23.0238 16.0902C25.7392 16.0902 27.9405 13.8889 27.9405 11.1735C27.9405 8.4581 25.7392 6.25684 23.0238 6.25684C20.3084 6.25684 18.1071 8.4581 18.1071 11.1735C18.1071 13.8889 20.3084 16.0902 23.0238 16.0902ZM30.75 21.7092C30.75 24.0368 27.2909 25.9235 23.0238 25.9235C22.4865 25.9235 21.962 25.8936 21.4555 25.8367C22.0118 25.2203 22.3214 24.5364 22.3214 23.8164C22.3214 21.8383 19.9853 20.1331 16.6173 19.3529C18.0057 18.2319 20.357 17.4949 23.0238 17.4949C27.2909 17.4949 30.75 19.3817 30.75 21.7092ZM11.0833 28.733C16.5141 28.733 20.9167 26.5318 20.9167 23.8164C20.9167 21.101 16.5141 18.8997 11.0833 18.8997C5.65254 18.8997 1.25 21.101 1.25 23.8164C1.25 26.5318 5.65254 28.733 11.0833 28.733Z",
    fill: "url(#paint0_linear_745_1438)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_745_1438",
    x1: 16,
    y1: 6.25684,
    x2: 16,
    y2: 28.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4056DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3746A3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipantsIcon);
export default __webpack_public_path__ + "static/media/participantsIcon.0ccd39f4564918ae0514d06f508d1989.svg";
export { ForwardRef as ReactComponent };